import React, {Component} from 'react';
import {Row, Table, Button, Col} from 'antd';

class TrainingIn extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const columns1 = [
                {
                    title: '序号',
                    dataIndex: '',
                    key: 'xh',
                    width: '5%',
                    render(text, record, index){
                        return index+1;
                    }
                },
                {
                    title: '培训课程',
                    dataIndex: 'rwdd',
                    key: 'rwdd',
                    width: '25%'
                },
                {
                    title: '目前报名人数',
                    dataIndex: 'rwzynr',
                    key: 'rwzynr',
                    width: '10%'
                },
                {
                    title: '培训后获得技能',
                    dataIndex: 'lasj',
                    key: 'lasj',
                    width: '25%'
                },
                {
                    title: '开始培训时间',
                    dataIndex: 'ks',
                    key: 'ks',
                    width: '10%'
                },
                {
                    title: '报名截止时间',
                    dataIndex: 'jz',
                    key: 'jz',
                    width: '10%'
                },
                {
                    title: '操作',
                    dataIndex: 'cz',
                    key: 'cz',
                    width: '15%',
                    render: (text, record) => {
                        return (
                            <Row type="flex" justify="center">
                                <Button type="primary" style={{marginRight: 10}} size="small">参加</Button>
                                <Button size="small" style={{marginLeft: 10}}>不参加</Button>
                            </Row>
                        )
                    }
                },
            ],
            columns2 = [
                {
                    title: '序号',
                    dataIndex: '',
                    key: 'xh',
                    width: '5%',
                    render(text, record, index){
                        return index+1;
                    }
                },
                {
                    title: '培训课程',
                    dataIndex: 'rwdd',
                    key: 'rwdd',
                    width: '25%'
                },
                {
                    title: '培训后获得技能',
                    dataIndex: 'lasj',
                    key: 'lasj',
                    width: '25%'
                },
                {
                    title: '开始培训时间',
                    dataIndex: 'ks',
                    key: 'ks',
                    width: '15%'
                },
                {
                    title: '报名截止时间',
                    dataIndex: 'jz',
                    key: 'jz',
                    width: '15%'
                },
                {
                    title: '操作',
                    dataIndex: 'cz',
                    key: 'cz',
                    width: '15%',
                    render: (text, record) => {
                        return (
                            <Row type="flex" justify="center">
                                <Button type="primary" style={{marginRight: 10}} size="small">参加</Button>
                                <Button size="small" style={{marginLeft: 10}}>不参加</Button>
                            </Row>
                        )
                    }
                },
            ],
            loading = this.state.data_loding,
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无培训信息',
            },
            dataSource = [
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                },
                {
                    rwdd: '吸貓教學培訓',
                    rwzynr: '12/20人',
                    lasj: '吸貓',
                    ks: '2018/03/29 12:15',
                    jz: '2018-03-29 12:15'
                }
            ];
        return (
            <div className="report-out train-in">
                <div className="page-title">参加培训<span>Training participation</span></div>
                <div className="page-content">
                    <Table columns={columns1} locale={locale} className="top-table" dataSource={dataSource} scroll={{y: 'calc(100% - 38px)'}} pagination={false}
                           size="small" title={() => <div className="table-title">公开报名<span>(参加公开培训的项目需要通过队长和省级管理员审核通过后才能成功报名)</span></div>}/>
                    <Table columns={columns2} locale={locale} className="bottom-table" dataSource={dataSource} scroll={{y: 'calc(100% - 38px)'}} pagination={false}
                           size="small" title={() => <div className="table-title">指定报名<span>(由队长或省级管理员直接指定培训项目，无需进行审核)</span></div>}/>
                </div>
            </div>
        );
    }
}

export default TrainingIn;



// WEBPACK FOOTER //
// ./src/routes/task/TrainingIn.jsx